export default "__VITE_ASSET__2f93d7bb__"